import React from 'react';
import SkeletonCard from '../../../../components/Skeleton/Card';

const Loading: React.FC = () => {
  return <SkeletonCard height={400} />;
};

export default Loading;
